/**
 * @generated SignedSource<<10251e89161286fe7331753ec95fae1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type aiConsultQuery$variables = {
  queryEnd: any;
  queryStart: any;
  recipientid: string;
};
export type aiConsultQuery$data = {
  readonly insurance_request_log_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly aiconsultdetailid: number | null | undefined;
        readonly caredetailid: number | null | undefined;
        readonly created_at: any | null | undefined;
        readonly id: string;
        readonly insuranceid: string;
        readonly recipient: {
          readonly email: string | null | undefined;
          readonly id: string;
          readonly imageurl: string | null | undefined;
          readonly last_seen: any;
          readonly name: string;
        } | null | undefined;
        readonly recipientid: string | null | undefined;
        readonly request_ai_consult_details: {
          readonly created_at: any;
          readonly id: string;
          readonly linkparameter: string;
          readonly startchatdate: any | null | undefined;
        } | null | undefined;
        readonly requeststatus: number;
        readonly requesttype: number;
      };
    }>;
  };
};
export type aiConsultQuery = {
  response: aiConsultQuery$data;
  variables: aiConsultQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryEnd"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryStart"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recipientid"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "order_by",
        "value": {
          "created_at": "asc"
        }
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_gte",
                "variableName": "queryStart"
              },
              {
                "kind": "Variable",
                "name": "_lte",
                "variableName": "queryEnd"
              }
            ],
            "kind": "ObjectValue",
            "name": "created_at"
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "recipientid"
              }
            ],
            "kind": "ObjectValue",
            "name": "recipientid"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_request_logConnection",
    "kind": "LinkedField",
    "name": "insurance_request_log_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "insurance_request_logEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "insurance_request_log",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "request_ai_consult_detail",
                "kind": "LinkedField",
                "name": "request_ai_consult_details",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkparameter",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startchatdate",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "users",
                "kind": "LinkedField",
                "name": "recipient",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageurl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "last_seen",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requeststatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requesttype",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recipientid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "insuranceid",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "caredetailid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiconsultdetailid",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiConsultQuery",
    "selections": (v5/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "aiConsultQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "a7a1f91722d1f42c789e0e4ead1173aa",
    "id": null,
    "metadata": {},
    "name": "aiConsultQuery",
    "operationKind": "query",
    "text": "query aiConsultQuery(\n  $recipientid: String!\n  $queryStart: timestamptz!\n  $queryEnd: timestamptz!\n) {\n  insurance_request_log_connection(where: {recipientid: {_eq: $recipientid}, created_at: {_gte: $queryStart, _lte: $queryEnd}}, order_by: {created_at: asc}) {\n    edges {\n      node {\n        request_ai_consult_details {\n          id\n          linkparameter\n          startchatdate\n          created_at\n        }\n        recipient {\n          id\n          email\n          imageurl\n          last_seen\n          name\n        }\n        requeststatus\n        requesttype\n        recipientid\n        insuranceid\n        id\n        created_at\n        caredetailid\n        aiconsultdetailid\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "93842141401af03e2cc31fbc268d2de7";

export default node;
